const timing = ({ value, name, category, label }) => {
  if (!process.browser || !window || !window.gtag) return false
  const timingObject = {
    value, // time in MS
    name
  }
  if (category) timingObject.event_category = category
  if (label) timingObject.event_label = label
  return window.gtag('event', 'timing_complete', timingObject)
}

const event = ({ action, category, label, value, nonInteractive }) => {
  if (!process.browser || !window || !window.gtag) return false
  const eventObject = {
    event_category: category,
    event_label: label,
    value
  }
  if (nonInteractive) eventObject.non_interaction = true
  return window.gtag('event', action, eventObject)
}

const pageview = url => {
  if (!process.browser || !window || !window.gtag) return false
  return window.gtag('config', process.env.GA_TRACKING_ID, {
    page_path: url
  })
}

const analytics = {
  pageview,
  event,
  timing,
  timingBuilder: ({ name, category, label, onFinish, onStart }) => {
    let startTime
    let finishTime
    const startFunc = () => {
      try {
        startTime = new Date().getTime()
        if (onStart && typeof onStart === 'function') onStart()
      } catch (error) {
        console.error('error [startFunc]', name, ' + ', error)
      }
    }
    const finishFunc = () => {
      try {
        finishTime = new Date().getTime()
        const value = finishTime - startTime
        timing({ value, name, category, label })
        if (onFinish && typeof onFinish === 'function') onFinish()
        return true
      } catch (error) {
        console.error('error [onFinish]', name, ' + ', error)
      }
    }
    return {
      start: startFunc,
      finish: finishFunc
    }
  }
}

export default analytics
